export default {
  form: '',
  fieldset: 'form-group',
  buttonLabel: '',
  radioButton: '',
}



// WEBPACK FOOTER //
// src/common/form-elements/radio-element-folder/radio-element.style.js